namespace GeniuzPOS.AdvPromo {
    export namespace Adv05ItemDetailService {
        export const baseUrl = 'AdvPromo/Adv05ItemDetail';

        export declare function Create(request: Serenity.SaveRequest<Adv05ItemDetailRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<Adv05ItemDetailRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<Adv05ItemDetailRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: AdvPromoDetailRequest, onSuccess?: (response: Serenity.ListResponse<Adv05ItemDetailRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/Adv05ItemDetail/Create",
            Update = "AdvPromo/Adv05ItemDetail/Update",
            Delete = "AdvPromo/Adv05ItemDetail/Delete",
            Retrieve = "AdvPromo/Adv05ItemDetail/Retrieve",
            List = "AdvPromo/Adv05ItemDetail/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>Adv05ItemDetailService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
